import Divider from "@mui/material/Divider";
import ChipSelect from "designSystem/components/chip/ChipSelect";
import { CheckedMenuItem } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import {
	ACTION_REVISION_ALL,
	ACTION_REVISION_CURRENT_SAMPLE,
	ACTION_REVISION_LATEST,
	ACTION_REVISION_NEXT,
	ACTION_REVISION_PREV,
	useCompareStore
} from "csi/page/ComparePageStore";
import { ATTR_PHASE_REVISIONS } from "csi/reflection/reflectionConstants";
import xml from "csi/xml";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

interface ChipSelectRevisionProps {
	/** flag to indicate compare menu */
	isCompareMenu?: boolean;

	/** callback for revision selection */
	onSelectRevision: (item: string, isCompareMenu: boolean) => void;
	
	/** callback for all revision selection */
	onSelectRevisionAll: (item: string, isCompareMenu: boolean) => void;

}

export const ChipSelectRevision: FunctionComponent<ChipSelectRevisionProps> = observer((props) => {
	const {
		compareNode,
		compareRevisionNode,
		compareProductNode,
		currentNode,
		currentRevisionNode,
		currentProductNode,
		readonlyMode,
	} = useCompareStore();
	
	const {
		isCompareMenu,
		onSelectRevision,
		onSelectRevisionAll,
	} = props;

	let bomNode = currentNode;
	let revisionNode = currentRevisionNode;
	let productNode = currentProductNode;
	if (isCompareMenu) {
		revisionNode = compareRevisionNode;
		productNode = compareProductNode;
		bomNode = compareNode;
	}

	const revisionUrls: string[] = bomNode.Revisions || [];
	const index = revisionUrls.indexOf(revisionNode.$URL);
	const lastIndex = index === revisionUrls.length - 1;
	const phaseRevisions = bomNode[ATTR_PHASE_REVISIONS];

	const loc = useLocale();

	return (
		revisionUrls.length && (
			<ChipSelect
				buttonRes="RevisionTitle"
				buttonResParams={[revisionNode.$Name]}
				disabled={readonlyMode}
			>
				<CheckedMenuItem
					checked={lastIndex}
					onClick={() => onSelectRevision(revisionUrls[revisionUrls.length - 1], isCompareMenu)}
					text={loc.resource(ACTION_REVISION_LATEST)}
				/>
				{
					xml.isValidURL(phaseRevisions.Production) && (
						<CheckedMenuItem
							checked={phaseRevisions.Sample === revisionNode.$URL}
							onClick={() => onSelectRevision(phaseRevisions.Sample, isCompareMenu)}
							text={loc.resource(ACTION_REVISION_CURRENT_SAMPLE)}
						/>
					)}
				<Divider />
				<CheckedMenuItem
					disabled={index === 0}
					onClick={() => onSelectRevision(revisionUrls[index - 1], isCompareMenu)}
					text={loc.resource(ACTION_REVISION_PREV)}
				/>
				<CheckedMenuItem
					disabled={lastIndex}
					onClick={() => onSelectRevision(revisionUrls[index + 1], isCompareMenu)}
					text={loc.resource(ACTION_REVISION_NEXT)}
				/>
				<Divider />
				<CheckedMenuItem
					onClick={() => onSelectRevisionAll(bomNode.$URL, isCompareMenu)}
					text={loc.resource(ACTION_REVISION_ALL)}
				/>
			</ChipSelect>
		)
	);
});

export default ChipSelectRevision;